import { buildUserAuthHeaders } from '../../../bridge/utils/userAuthHeaders';

/** localStorage key for the IMS access token (must match ImsApi). */
export const IMS_ACCESS_TOKEN_CACHE_KEY = 'imsAccessToken';

export function getCachedImsAccessToken(): string | null {
	return localStorage.getItem(IMS_ACCESS_TOKEN_CACHE_KEY);
}

/** localStorage key for the IMS account id used to identify error reports. */
export const IMS_AUTH_ID_CACHE_KEY = 'imsAuthId';

/**
 * The OAuth popup is its own window, and it can report a failure before its own
 * IMS profile request returns. It shares localStorage with the window that
 * opened it, so the cached id gives that early failure an account.
 */
export function getCachedImsAuthId(): string | null {
	return localStorage.getItem(IMS_AUTH_ID_CACHE_KEY);
}

export function setCachedImsAuthId(authId: string): void {
	localStorage.setItem(IMS_AUTH_ID_CACHE_KEY, authId);
}

export function clearCachedImsAuthId(): void {
	localStorage.removeItem(IMS_AUTH_ID_CACHE_KEY);
}

/** Headers for beacon-ui-proxy and other outbound UI requests. */
export function getProxyAuthHeaders(
	token?: string | null,
): Record<string, string> {
	const imsToken = token ?? getCachedImsAccessToken();
	return buildUserAuthHeaders(imsToken ?? undefined, { contentType: false });
}
